import { RemoveConsumptionModal } from "./RemoveConsumptionModal";

export default RemoveConsumptionModal;
